<template>
  <div class="savedList">
    <adx-sidebar />
    <div class="savedListMain container-router">
      <div class="savedListMain__header">
        <div class="savedListMain__header__title">
          <div class="maintitle">
            <input ref="title" class="maintitle--input medium-title strong" :class="{bottom:isEdit}" disabled @keyup="keyTitle">
            <template v-if="isEdit">
              <span @click="setTitle"><i class="icon-check"></i></span>
              <span @click="closeTitle"><i class="icon-close"></i></span>
            </template>
            <span v-else-if="!isSavedDefault()" @click="editTitle"><i class="icon-edit"></i></span>
          </div>
          <div v-if="titleError" class="errortitle">
            <span class="small-font">Ensure this field has no more than 191 characters.</span>
          </div>
          <div class="subtitle">
            <p>Created on {{formatDate(saved.created)}} • {{saved.item_count}} items</p>
          </div>
        </div>
        <div class="savedListMain__header__action">
          <div class="savedListMain__header__action--left">
            <button class="first btn-regular primary" @click="showCampaign">Add to campaign</button>
          </div>
            <div class="savedListMain__header__action--right desktop">
              <span>Filter :</span>
              <div class="filter">
                <adx-dropdown-filter :type="true" :value.sync="selectedFilter" :label="`Select filter`" :options="filter" />
              </div>
            </div>
            <div class="savedListMain__header__action--right mobile">
              <adx-dropdown-list class="sort-mobile" @selected="setFilter" :list="filter" :labelButton="filterLabel" :title="`Filter`" />
            </div>
        </div>
      </div>
      <div class="savedListMain__content">
        <adx-loading v-if="isLoading" slot="loading" />
        <div v-else-if="lists.length == 0" class="savedListMain__content__empty-state">
          <adx-empty />
        </div>
        <div v-else class="savedListMain__content__list" v-for="(category, index) in lists" :key="index">
          <div class="savedListMain__content__list--title">
            <h2 class="small-title">{{categoryTitle(category.title)}}</h2>
          </div>
          <adx-list-item :category="category.title.toLowerCase()" :items='category.items' @createNew="createNew" @reloadData="reloadData" :menuList="expansionList"
          @item-clicked="gotoDetail($event)" @createNewCampaign="createNewCampaign"/>
        </div>
      </div>
      <adx-modal v-if="isCreateSaved" :hide-close="true" title="Start to create saved" @modal-close="isCreateSaved = false" type='small' :noTitle="true">
        <div class="savedListMain__modal" slot="content">
          <div class="savedListMain__modal__input">
            <input ref="input" type="text" @keyup="KeyUp">
            <label class="subhead">Folder Name</label>
          </div>
          <div class="savedListMain__modal__buttons">
            <button class="btn-regular secondary" @click="isCreateSaved = false">Cancel</button>
            <button class="btn-regular primary" :disabled="newTitle === ''"
            @click="createFolder">Save</button>
          </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isShownCampaign" :noTitle="isMobile == false" :noTitleTop="isMobile == true" @modal-close="isShownCampaign = false" :type="!isMobile ? 'small' : ''">
        <div class="savedListMain__campaign" slot="content">
          <h2 class="small-title">Add to campaign</h2>
          <button class="btn-block primary" @click="createCampaignUntitled">
            Create new campaign
            <div class="primary__load">
              <adx-loading-spin v-if="isCreateCampaignLoad" slot="loading"/>
            </div>
          </button>
          <div class="savedListMain__campaign__break">
            <span>OR</span>
          </div>
          <h2 class="small-title">Add to current campaign</h2>
          <div class="load">
            <adx-loading v-if="isLoadingCampaign" slot="loading" />
          </div>
          <ul class="savedListMain__campaign__list">
            <li v-for="(item, index) in campaigns" :key="index" @click="appendCampaign(item.id)" class="savedListMain__campaign__list__item">
              <p> {{item.title}} </p>
              <div class="savedListMain__campaign__list__item__load">
                <adx-loading-spin-red v-if="isLoadingAppend.includes(item.id)" slot="loading"/>
              </div>
            </li>
          </ul>
        </div>
      </adx-modal>
      <adx-modal v-if="isCreateCampaign" :hide-close="true" title="Start to create campaign" @modal-close="toggleModalCampaign" type='small' :noTitle="true">
        <div class="savedListMain__modal" slot="content">
          <div class="savedListMain__modal__input">
            <input ref="input" type="text" @keyup="KeyUpCampaign">
            <label class="subhead">Campaign Name</label>
          </div>
          <div class="savedListMain__modal__buttons">
            <button class="btn-regular secondary" @click="toggleModalCampaign">Cancel</button>
            <button class="btn-regular primary" :disabled="newTitle === ''"
            @click="createCampaign">Save</button>
          </div>
        </div>
      </adx-modal>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/SideBar/Desktop'
import DropdownFilter from '@/components/Form/SelectDropdown'
import DropdownList from '@/components/Dropdown/ListDropdown'
import ListItems from '@/views/SavedList/ListItems'
import Empty from '@/components/NotFound/Saved'
import Loading from '@/components/Loading/Primary'
import LoadingSpinRed from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import Modal from '@/components/Modal'
import Media from 'vue-media'
import api from '@/api/'
import { apiV2 } from '@/api/urls'
import { formatShortDate } from '@/lib/util'

export default {
  name: 'adx-',
  head: {
    title: {
      inner: 'Saved List',
    }
  },
  components: {
    'adx-sidebar': Sidebar,
    'adx-dropdown-filter': DropdownFilter,
    'adx-dropdown-list': DropdownList,
    'adx-list-item': ListItems,
    'adx-modal': Modal,
    'adx-empty': Empty,
    'adx-loading': Loading,
    'adx-loading-spin': LoadingSpin,
    'adx-loading-spin-red': LoadingSpinRed,
    Media
  },
  data() {
    return {
      isLoadingCampaign: true,
      isLoadingAppend: [],
      isCreateCampaign: false,
      isCreateCampaignLoad: false,
      isMobile: window.innerWidth < 769,
      isLoading: true,
      filter: [
        {
          id: 0,
          label: "All",
          value: "-"
        }
      ],
      isHover: null,
      isShowMore: false,
      isShownCampaign: false,
      allShown: false,
      isEdit: false,
      isCreateSaved: false,
      newTitle: '',
      titleError: false,
      renameTitle: '',
      createParams: {},
      selectedFilter: '-',
      filterLabel: 'Filter',
      saved: {},
      campaigns: [],
      expansionList: [],
      lists: [],
      newCampaign: true,
    }
  },
  computed: {

  },
  watch: {
    selectedFilter() {
      if (this.selectedFilter != '-'){
        this.mapping(this.selectedFilter)
      } else {
        this.mapping()
      }
    }
  },
  mounted() {
    this.loadData()
    this.loadSavedandCampaign()
  },
  methods: {
    showCampaign(){
      this.isShownCampaign = true
      this.getCampaigns()
    },
    getCampaigns() {
      if (this.campaigns.length == 0){
        (async () => {
          this.isLoadingCampaign = true
          const response = await api.get(apiV2.draftCampaigns, { needToken: true })
          this.isLoadingCampaign = false
          if (response.status == 200) {
            this.campaigns = response.data
          } else {
            // this.error = response.data.error
          }
        })();
      }
    },
    appendCampaign(id) {
      if (this.isLoadingAppend.length == 0) {
        (async () => {
          this.isLoadingAppend.push(id)
          const data = {
            channel_name: 'saved',
            list_channel_id: [this.$route.params.id]
          }
          const response = await api.patch(apiV2.campaignAddBulkListing(id), data, { needToken: true })
          this.isLoadingAppend = []
          if (response.status == 200) {
            this.$router.push({ path: `/${id}/campaign-editor` })
          } else {
            this.error = response.data.error
          }
        })();
      }
    },
    createCampaignUntitled() {
      (async () => {
        this.isCreateCampaignLoad = true
        const data = {
          campaign_channel: [
            {
              name: 'saved',
              list_id: [this.$route.params.id]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaignLoad = false
        if (response.status == 201) {
          this.$router.push({ name: 'campaigneditorpage', params: { id: response.data['data']['id'], newCampaign: this.newCampaign }})
        } else {
          this.error = response.data.error
        }
      })();
    },
    categoryTitle(string) {
      if (string === `Spbu`) {
        return string.toUpperCase()
      }
      return string
    },
    isSavedDefault(){
      if(this.$store.getters.defaultSaved == this.$route.params.id){
        return true
      }else {
        return false
      }
    },
    formatDate(date){
      return formatShortDate(date)
    },
    closeTitle() {
      this.titleError = false
      this.isEdit = false
      this.$refs.title.disabled = true
      this.$refs.title.value = this.renameTitle
    },
    setTitle() {
      if (this.$refs.title.value.length < 191) {
        this.titleError = false
        this.isEdit = false
        this.$refs.title.disabled = true
        this.renameTitle = this.$refs.title.value

        let data = {
            'title': this.$refs.title.value
        };

        (async () => {
          const response = await api.put(apiV2.savedDetail(this.$route.params.id), data, { needToken: true })
        })();
      } else {
        this.titleError = true
      }
      
    },
    editTitle() {
      this.isEdit = true
      this.$refs.title.disabled = false
      this.$refs.title.focus()
    },
    setFilter(item) {
      this.selectedFilter = item.value?item.value:'-'
    },
    keyTitle (ev) {
      if (ev.keyCode == 13) {
        this.setTitle()
      }
    },
    KeyUp(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createFolder()
      }
    },
    KeyUpCampaign(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createCampaign()
      }
    },
    gotoDetail({ item }) {
      let category = item.category_display
      if (item.pub_id) {
        const { pub_id } = item
        const path = `/detail/${category}/${pub_id}/`
        this.$router.push({ path: path })
      }
    },
    createNew(params) {
      this.createParams = params
      this.isCreateSaved = true
    },
    createFolder(){
      (async () => {
        this.createParams['title'] = this.newTitle
        const response = await api.post(apiV2.saved, this.createParams, { needToken: true })
        if (response.status == 201) {
          this.isCreateSaved = false
          this.loadSavedandCampaign()
        }
      })();
    },
    loadSavedandCampaign() {
      this.expansionList = [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "saved",
          "items": [
            {
              "name": "Create new saved",
              "value": 0
            }
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "campaign",
          "items": [
            {
              "name": "Create new campaign",
              "value": 0
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "detail"
        }
      ]
      this.loadSaved()
      this.loadCampaigns()
    },
    loadSaved() {
      (async () => {
        const { data } = await api.get(apiV2.saved, { needToken: true })
        data.map(el => {
          if (el.id !== parseInt(this.$route.params.id)) {
            this.expansionList[0]['items'].push({
              "name": el.title,
              "value": el.id
            })
          }
        })
      })();
    },
    loadCampaigns() {
      (async () => {
        const response = await api.get(apiV2.draftCampaigns, { needToken: true })
        if (response.status == 200) {
          const { data } = response
          data.map(el => {
            this.expansionList[1]['items'].push({
              "name": el.title,
              "value": el.id
            })
          })
        } else {
          // this.error = response.data.error
        }
      })();
    },
    toggleModalCampaign() {
      this.isCreateCampaign = !this.isCreateCampaign
    },
    createNewCampaign(params) {
      this.createParams = params
      this.isCreateCampaign = true
    },
    createCampaign() {
      (async () => {
        const data = {
          title: this.newTitle,
          campaign_channel: [
            {
              name: this.createParams.category,
              list_id: [this.createParams.device_id]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaign = false
        if (response.status == 201) {
          this.isCreateCampaign = false
          this.$notify({
            group: 'saved',
            title: 'Added to campaign',
            text: this.createParams.location_name + ' has been added to ' + this.newTitle,
            type: 'success'
          });
          this.loadSavedandCampaign()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
      })();
    },
    loadFilter() {
      let list = this.saved.lists
      Object.keys(list).map((key, index) => {
        if (list[key].length > 0) {
          this.filter.push({
            id: index + 1,
            label: key === `spbu` ? key.toUpperCase() : key.charAt(0).toUpperCase() + key.substr(1),
            value: key
          })
        }
      })
    },
    reloadData() {
      let params = {};
      (async () => {
        const { data } = await api.get(apiV2.savedDetail(this.$route.params.id), { ...params, needToken: true })
        this.saved = data
        this.$refs.title.value = data.title

        let empty = false
        this.lists.map((obj) => {
          if (this.selectedFilter == obj.title.toLowerCase()) {
            if (obj.items.length == 1) empty = true
          }
        })

        if(empty) {
          this.filter = [{
            id: 0,
            label: "All",
            value: "-"
          }]
          this.selectedFilter = '-'
          this.filterLabel = 'All'
          this.loadFilter()
        } 

        if (this.selectedFilter !== '-') {
          this.mapping(this.selectedFilter)
        } else {
          this.mapping()
        }
      })();
    },
    loadData() {
      (async () => {
        this.isLoading = true
        const { data } = await api.get(apiV2.savedDetail(this.$route.params.id), { needToken: true })
        this.saved = data
        this.$refs.title.value = data.title
        this.renameTitle = data.title
        this.mapping()
        if (this.filter.length == 1) {
          this.loadFilter()
        }
        this.isLoading = false
      })();
    },
    mapping (category=null) {
      let list = this.saved.lists
      this.lists = []
      Object.keys(list).map((key, index) => {
        if (list[key].length > 0) {
          if (category) {
            if (category == key) {
              this.lists.push({
                title: key.charAt(0).toUpperCase() + key.substr(1),
                items: list[key]
              })
            }
          } else {
            this.lists.push({
              title: key.charAt(0).toUpperCase() + key.substr(1),
              items: list[key]
            })
          }
        }
      })
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>